import React from "react";
import PropTypes from "prop-types";
import { htmlEncode, dec2hex } from "../../util";

const VisualizationTooltip = React.forwardRef(
  (
    { title, tooltipData, closeTooltip, changeTooltipPage, svgParams },
    tooltipRef
  ) => {
    const names = tooltipData.names;
    const instructions = tooltipData.instructions;
    const is64Bit = String(title).indexOf("PE32+ ") === 0;
    const totalPages = tooltipData.pages.total;
    const currentPageNum = tooltipData.pages.currentPage;
    const showControls = totalPages > 1;
    const positionTop = tooltipData.position.top;
    const positionLeft = tooltipData.position.left;
    const controlBtnClasses = {
      prev: currentPageNum === 1 ? "disabled" : "",
      next: currentPageNum === totalPages ? "disabled" : ""
    };
    const tableOffset = {
      transform: `translateX(-${(currentPageNum - 1) * 100}%)`
    };

    return (
      names && (
        <div
          ref={tooltipRef}
          className="file-visualization__tooltip"
          style={{
            width: svgParams.tooltipW,
            top: positionTop,
            left: positionLeft
          }}
        >
          <span
            className="file-visualization__tooltip-close-btn"
            onClick={() => closeTooltip()}
          >
            <span className="icon-close"></span>
          </span>
          {showControls && (
            <div className="file-visualization__tooltip-controls">
              <span
                className={`file-visualization__tooltip-btn ${controlBtnClasses.prev}`}
                onClick={() => {
                  changeTooltipPage("prev");
                }}
              >
                <span className="icon-prev"></span>
              </span>
              <div className="file-visualization__tooltip-slide-num">
                {currentPageNum} / {totalPages}
              </div>
              <span
                className={`file-visualization__tooltip-btn ${controlBtnClasses.next}`}
                onClick={() => {
                  changeTooltipPage("next");
                }}
              >
                <span className="icon-next"></span>
              </span>
            </div>
          )}
          <div className="file-visualization__tables-wrap" style={tableOffset}>
            {names.map((nameItem, nameIndex) => {
              const instructionItemExists = instructions.length > nameIndex;
              return (
                <table key={nameIndex} className="file-visualization__table">
                  <caption>{htmlEncode(nameItem.name)}</caption>
                  <thead>
                    <tr>
                      <th className="p-address">address</th>
                      <th className="p-disassembly">disassembly</th>
                      <th className="p-comment">comment</th>
                    </tr>
                  </thead>
                  <tbody>
                    {instructions.length ? (
                      instructionItemExists &&
                      instructions[nameIndex].map(
                        (instructionItem, instructionIndex) => {
                          const address = dec2hex(
                            parseInt(instructionItem.address, 10),
                            is64Bit
                          );
                          const comment = instructionItem.comment;
                          const disasm = instructionItem.disasm;

                          return (
                            <tr key={instructionIndex}>
                              <td>0x{address}</td>
                              <td>{disasm}</td>
                              {comment ? (
                                <td
                                  className="file-visualization__table-comment-cell"
                                  title={htmlEncode(comment)}
                                >
                                  <span>{htmlEncode(comment)}</span>
                                </td>
                              ) : (
                                <td>&nbsp;</td>
                              )}
                            </tr>
                          );
                        }
                      )
                    ) : (
                      <tr>
                        <td style={{ width: "200px" }}>No Data Available</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              );
            })}
          </div>
        </div>
      )
    );
  }
);

VisualizationTooltip.propTypes = {
  title: PropTypes.string,
  tooltipData: PropTypes.shape(),
  closeTooltip: PropTypes.func,
  changeTooltipPage: PropTypes.func,
  svgParams: PropTypes.shape()
};

export default VisualizationTooltip;
